import BackgroundGraph from './BackgroundGraph';

export default BackgroundGraph;
